import { Chart, ChartTimerName } from '@frontend/chart/types';

export const TRANSACTION_TIMER_DROP_OFF_PENDING_DURATION_METRIC_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: ChartTimerName.TRANSACTION_DROP_OFF_PENDING,
            data: [
                { label: '2026-06-01', value: 98000 },
                { label: '2026-07-01', value: 102273 },
                { label: '2026-08-01', value: 90000 }
            ]
        }
    ]
};
